module.exports = __webpack_public_path__ + "static/img/party@3x.18168ae6.png";